import { useCookies } from 'react-cookie';
import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import FadeIn from "react-fade-in/lib/FadeIn"
import { getCurrentRole, getStyle, getBizID, getServices } from "../../libs/todoSlice";
 
import { getLoadingRedux, setLoadingRedux } from "../../libs/manageMemberSlice";
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import CreateIcon from '@mui/icons-material/Create';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import Swal from "sweetalert2";
import fontColor from "../../lib/fontColor";
import Button from '@mui/material/Button';
import Switch from '@mui/material/Switch'; 
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import ReactQuill from "react-quill";
import { InputLabel } from '@mui/material';
import { styled } from '@mui/material/styles';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { Card, Table, Empty, Radio, Space, Input, Typography, Dropdown, Menu } from 'antd';
import { Row, Col } from 'react-bootstrap';
import { UnorderedListOutlined, CloseCircleOutlined, FileSearchOutlined } from '@ant-design/icons';
 

const caMappings = ["{{EXPIRY_DATE_CA}}", "{{REQUEST_ID}}"];

const mappings = {
    'ชื่อผู้ใช้': '{{USERNAME}}',
    'รหัสผ่าน': '{{PASSWORD}}',
    'ชื่อองค์กร': '{{NAME_BIZ}}',
    'อีเมลผู้รับ': '{{EMAIL_USER}}',
    'ชื่อผู้รับ(TH)': '{{NAME_USER}}',
    'ชื่อผู้รับ(EN)': '{{NAME_USER_EN}}',
    'อีเมลสำหรับแจ้งปัญหา': '{{EMAIL_SUPPORT}}',
    'ลิ้งเว็บไซต์': '{{URL}}',
    'วันหมดอายุ(ca)': '{{EXPIRY_DATE_CA}}',
    'ชื่อใบรับรอง': '{{REQUEST_ID}}'
};

const templateTypeList = [
    "one-id",
    "one-id-pmuc",
    "one-id-ra",
    "edu-student-pre-register",
    "edu-student-pre-register-combine",
    "edu-teacher-pre-register",
    "edu-officer-pre-register",
    "medical-pre-register",
    "time-attendance-pre-register",
    "moph-caregiver-pre-register",
    "corporation-pre-register",
    "renew-ca",
];

const templateDisplay = {
    "renew-ca": "ต่ออายุหนังสือรับรอง(CA)",
    "one-id":"one-id",
    "one-id-pmuc":"one-id-pmuc",
    "one-id-ra":"one-id-ra",
    "edu-student-pre-register":"รอลงทะเบียนสำหรับนักเรียน/นักศึกษา",
    "edu-student-pre-register-combine":"รอลงทะเบียนสำหรับนักเรียน/นักศึกษา (combine)",
    "edu-teacher-pre-register":"รอลงทะเบียนสำหรับครู/อาจารย์",
    "edu-officer-pre-register":"รอลงทะเบียนสำหรับเจ้าหน้าที่",
    "medical-pre-register":"รอลงทะเบียนสำหรับบุคลากรทางการแพทย์",
    "time-attendance-pre-register":"รอลงทะเบียนเช็คชื่อนักเรียน",
    "moph-caregiver-pre-register":"รอลงทะเบียนสำหรับผู้ดูแลผู้ป่วย",
    "corporation-pre-register":"รอลงทะเบียนสำหรับสมาชิก"   
};

const EmailTemplate = () => {
    const [cookie, setCookie, removeCookie] = useCookies(['account'])
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const style = useSelector(getStyle)
    const [step, setStep] = useState('home');
    const [template, setTemplate] = useState('')
    const biz_id = useSelector(getBizID)
    const services = useSelector(getServices)

    const [pageSize, setPageSize] = useState(10)
    const [page, setPage] = useState(1)
    const [listData, setListData] = useState('')
    const [countListData, setCountListData] = useState(0)
    const [defaultListData, setDefaultListData] = useState([])
    const [statusID, setStatusID] = useState('')
    const [isRenewCa, setIsRenewCa] = useState(false)
    const [isRenewCaUpdate, setIsRenewCaUpdate] = useState(false)

    useEffect(() => {
        
    }, [cookie,step]);

    const loading = useSelector(getLoadingRedux)
    const setLoading = (action) => {
        dispatch(setLoadingRedux({
        loading: action
        }))
    }

    const currentRole = useSelector(getCurrentRole)
    const [searchText, setSearchText] = useState('')
    const [valueCheck, setValueCheck] = useState("use-inet");
    const [isEnabled, setIsEnabled] = useState(true);
    const [valueTab, setValueTab] = useState('1');
    const [radioValue, setRadioValue] = useState('หัวข้อ');
    const [selectValue, setSelectValue] = useState('');
    const [selectType, setSelectType] = useState('one-id');
    const [emailSubject, setEmailSubject] = useState('');
    const [data, setData] = useState([]);
    const [error, setError] = useState('');

    const customLocale = {
        emptyText: (<Empty description="ไม่มีข้อมูล" />)
    };



    const EnabledSwitch = styled((props) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    ))(({ theme }) => ({
        width: 42,
        height: 26,
        padding: 0,
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: 2,
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(16px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: `${style.secondary_color} !important`,
                    opacity: 1,
                    border: 0,
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 0.5,
                },
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 22,
            height: 22,
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
        },
    }));

    const handleInfo = (record) => {
        getDetailTemplate(record)
        setStep('info')
    };

    const handleSelectTypeChange = (event) => {
        setSelectType(event.target.value);
        if(event.target.value === 'renew-ca'){
            setIsRenewCa(true)
            
        }else{
            setIsRenewCa(false)
        }

        const hasAnyCAMapping = caMappings.some(tag => templateSubject.includes(tag));

        if ( event.target.value !== 'renew-ca' && templateSubject !== '' && hasAnyCAMapping) {
            const updatedTemplateSubject = caMappings.reduce(  (result, tag) => result.replaceAll(tag, ''), templateSubject ); 
            setTemplateSubject(updatedTemplateSubject);
        }

        // const hasAnyCAMapping = caMappings.some(tag => templateSubject.includes(tag));
        // if(event.target.value !== 'renew-ca' && templateSubject !== '' && hasAnyCAMapping){ 
        //     const updatedTemplateSubject = templateSubject.replace(caMappings, '');
        //     console.log('updatedTemplateSubject ', updatedTemplateSubject)
        //     setTemplateSubject(updatedTemplateSubject)
        // }

    };

    const paginationStyle = {
        display: 'flex',
        justifyContent: 'right',
    };

    const handleChangeTab = (event, newValue) => {
        setValueTab(newValue);
    };

    const CustomCard = styled(Card)`
        .ant-card-head {
            background-color: #357791;
        }
    `;

    const [cardHeight, setCardHeight] = useState(0);
    const cardRef = useRef(null);

    const updateHeight = () => {
        if (cardRef.current) {
            const newHeight = cardRef.current.offsetHeight;
            setCardHeight(newHeight);
        }
    };

    const setCardRef = (node) => {
        cardRef.current = node;
        updateHeight();
    };

    useEffect(() => {
        updateHeight();
    }, []);

    useEffect(() => {
        window.addEventListener('resize', updateHeight);
        return () => window.removeEventListener('resize', updateHeight);
    }, [])

    const quillRef = useRef(null)
    const handleRadioChange = (e) => {
        setRadioValue(e.target.value);
        setSelectValue(''); 
        if (e.target.value === 'เนื้อหา') {
            setSelectValue('');
        }
    }

    const handleSelectChange = (e) => {
        console.log('e.target.value ', e.target.value)
        setSelectValue(e.target.value); 
        const placeholderText = mappings[e.target.value] || '';
        if (radioValue === 'หัวข้อ') {
            setTemplateSubject((prev) => prev + placeholderText)
        } else {
            const quill = quillRef.current.getEditor();
            const range = quill.getSelection();

            if (range) {
                quill.insertText(range.index, placeholderText);
                quill.setSelection(range.index + placeholderText.length);
            }
        }
    }

    useEffect(() => {
        getTemplate()
    }, [page, pageSize, searchText])

    const monthNamesTH = [
        'ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.',
        'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'
    ];
    const formatDate = (isoString) => {
        if (!isoString) return '-';
        const date = new Date(isoString);
        const day = (`0${date.getDate()}`).slice(-2);
        const month = monthNamesTH[date.getMonth()];
        const year = date.getFullYear();
        const hours = (`0${date.getHours()}`).slice(-2);
        const minutes = (`0${date.getMinutes()}`).slice(-2);
        const seconds = (`0${date.getSeconds()}`).slice(-2);

        return `${day} ${month} ${year} ${hours}:${minutes}:${seconds}`;
    };

    
    const templateAvailable = templateTypeList.filter(key => services.includes(key)).map(key => ({ key, label: templateDisplay[key] }));
    
    const getTemplate = async () => {
        try {
          const { data, status } = await axios({
            method: 'GET',
            url: `${process.env.REACT_APP_BACKEND_URL}/api/v1/email/template/list?biz_id=${biz_id}`,
            params: {
                page: page,
                size: pageSize,
                searching: searchText
            }
          })
          const list = data.data.data
          let list_data = list.map((list, index) => {
            setIsRenewCaUpdate(list.template_type)
            return {
              index: index + 1,
              template_name: list.template_name ? list.template_name : '-',
              template_type: list.template_type ? templateDisplay[list.template_type] : 'one-id',
              date: formatDate(list.updatedAt),
              id: list._id,
              operated: list.userDetails,
              enabled: list.active
            }
          })
          setListData(list_data)
          setCountListData(data.data.total)
          setDefaultListData(list_data)
          setStatusID(list_data.length > 0 ? list_data[0].id : '')
        } catch ({ response }) {

        }
    };

    const [templateID, setTemplateID] = useState('')
    const [templateNameDetail, setTemplateNameDetail] = useState('')
    const [templateSubjectDetail, setTemplateSubjectDetail] = useState('')
    const [templateDetailInfo, setTemplateDetailInfo] = useState('')
    const getDetailTemplate = async (record) => {
        setLoading(true)
        await axios({
          method: 'GET',
          url: `${process.env.REACT_APP_BACKEND_URL}/api/v1/email/template?biz_id=${biz_id}&template_id=${record.id}`,
        }).then(({ data, status }) => {
          let account = { ...data.data }
          setTemplateID(account._id)
          setTemplateNameDetail(account.template_name)
          setTemplateSubjectDetail(account.template_subject)
          setTemplateDetailInfo(account.template_detail)
        
        }, ({ response }) => {

        })
        setLoading(false)
    };

    const [templateName, setTemplateName] = useState('')
    const [templateSubject, setTemplateSubject] = useState('')
    const [templateDetail, setTemplateDetail] = useState('')
    const [errors, setErrors] = useState({})
    const [templateEditObj, setTemplateEditObj] = useState({})

    const createTemplate = async () => {
        setLoading(true);
        setErrors({})

        const newErrors = {};
        if (!templateName) newErrors.templateName = 'กรุณากรอกชื่อ Template';
        if (!templateSubject) newErrors.templateSubject = 'กรุณากรอกหัวข้ออีเมล';
        if (!templateDetail) newErrors.templateDetail = 'กรุณากรอกรายละเอียด';

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            setLoading(false);
            return;
        }

        try {
            const result = await Swal.fire({
                title: "คุณต้องการบันทึก Template ใหม่หรือไม่",
                showCancelButton: true,
                confirmButtonText: "ยืนยัน",
                cancelButtonText:"ยกเลิก"
                // denyButtonText: `Don't save`
            });

            // Check user confirmation
            if (result.isConfirmed) {
                const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/email/template`, {
                    biz_id: biz_id,
                    template_name: templateName,
                    template_subject: templateSubject,
                    template_detail: templateDetail,
                    template_type: selectType,

                });
    
                if (response.status === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'บันทึกข้อมูลสำเร็จ',
                        showConfirmButton : false,

                    }).then(() => {
                        setStep('home');
                        getTemplate(); // Refresh templates
                    });
                }
            }
        } catch (error) {
            const { status } = error.response || {};
            Swal.fire({
                icon: status === 400 ? 'question' : 'error' ,
                title: 'บันทึกข้อมูลไม่สำเร็จ',
                text: status === 400 ? 'ข้อมูลไม่ถูกต้อง' : 'เกิดข้อผิดพลาดในการบันทึก',
                confirmButtonText: "ตกลง",

            });
        } finally {
            setLoading(false);  // Ensure loading stops whether successful or not
        }
    };

    const handleEdit = async (record) => {
        await axios({
            method: 'GET',
            url: `${process.env.REACT_APP_BACKEND_URL}/api/v1/email/template?biz_id=${biz_id}&template_id=${record.id}`,
          }).then(({ data, status }) => {
            setTemplateEditObj({ ...data.data, template_id: record.id })
          
          }, ({ response }) => {
          })
        setStep('edit');
    };

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setTemplateEditObj(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSelectEditChange = (e) => {
        setSelectValue(e.target.value); 

        const placeholderText = mappings[e.target.value] || '';

        if (radioValue === 'หัวข้อ') {
            setTemplateEditObj((prev) => ({
                ...prev,
                template_subject: (prev.template_subject || '') + placeholderText
            }));
        } else {
            const quill = quillRef.current.getEditor();
            const range = quill.getSelection();

            if (range) {
                quill.insertText(range.index, placeholderText);
                quill.setSelection(range.index + placeholderText.length);
            }
        }
    };
    
    const saveEditTemplate = async () => {
        setLoading(true);
        setErrors({});
    
        const newErrors = {};
        if (!templateEditObj.template_name) newErrors.templateNameEdit = 'กรุณากรอกชื่อ Template';
        if (!templateEditObj.template_subject) newErrors.templateSubjectEdit = 'กรุณากรอกหัวข้ออีเมล';
        if (!templateEditObj.template_detail) newErrors.templateDetailEdit = 'กรุณากรอกรายละเอียด';
    
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            setLoading(false);
            return;
        }
    
        try {
            const result = await Swal.fire({
                title: "คุณต้องการแก้ไข Template นี้หรือไม่",
                showCancelButton: true,
                confirmButtonText: "ยืนยัน",
                cancelButtonText: "ยกเลิก"
            });
    
            if (result.isConfirmed) {
                const response = await axios.patch(`${process.env.REACT_APP_BACKEND_URL}/api/v1/email/template`, {
                    biz_id: biz_id,
                    template_id: templateEditObj.template_id,
                    template_name: templateEditObj.template_name,
                    template_subject: templateEditObj.template_subject,
                    template_detail: templateEditObj.template_detail
                });
    
                if (response.status === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'แก้ไขข้อมูลสำเร็จ',
                        showConfirmButton: false,
                    }).then(() => {
                        setStep('home');
                        getTemplate(); // Refresh templates
                    });
                }
            }
        } catch (error) {
            const { status } = error.response || {};
            Swal.fire({
                icon: status === 400 ? 'question' : 'error',
                title: 'แก้ไขข้อมูลไม่สำเร็จ',
                text: status === 400 ? 'ข้อมูลไม่ถูกต้อง' : 'เกิดข้อผิดพลาดในการแก้ไข',
                confirmButtonText: "ตกลง",
            });
        } finally {
            setLoading(false);
        }
    };
    

    const handleDelete = (record) => {
        Swal.fire({
            title: "ต้องการลบข้อมูลนี้ใช่หรือไม่?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "ยืนยัน"
          }).then((result) => {
            if (result.isConfirmed) {
                deleteTemplate(record)
            }
          });
    };

    const deleteTemplate  = async (record) => {
        setLoading(true)
        await axios({
          method: 'DELETE',
          url: `${process.env.REACT_APP_BACKEND_URL}/api/v1/email/template?biz_id=${biz_id}&template_id=${record.id}`,
        }).then(() => {
            Swal.fire({
                title: "ลบข้อมูลสำเร็จแล้ว",
                icon: "success"
            }).then(() => {
                setListData(listData.filter(e => e._id !== record.id).map((e, index) => {
                    return {
                        ...e,
                        index: index + 1,
                    }
                }))
                setDefaultListData(defaultListData.filter(e => e._id !== record.id).map((e, index) => {
                    return {
                        ...e,
                        index: index + 1,
                    }
                }))
                setCountListData(countListData - 1)
                window.location.reload();
            })
        }, ({ response }) => {
            Swal.fire({
                title: "เกิดข้อผิดพลาด",
                text: "ไม่สามารถลบข้อมูลได้",
                icon: "error"
            });
        })
        setLoading(false)
    };

    const handleSwitchChange = async (event, record) => {
        const newStatus = event.target.checked;
        const result = await Swal.fire({
            title: newStatus ? 'ต้องการเปิดใช้งานไหม?' : 'ต้องการปิดใช้งานไหม?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'ตกลง',
            cancelButtonText: 'ยกเลิก'
        });

        if (result.isConfirmed) {
            try {
                await ChangeStatus(record.id, newStatus, record.template_type);
                setData((prevData) =>
                    prevData.map((item) =>
                        item.key === record.key ? { ...item, enabled: newStatus } : item
                    )
                );
            } catch (error) {
                setData((prevData) =>
                    prevData.map((item) =>
                        item.key === record.key ? { ...item, enabled: !newStatus } : item
                    )
                );
            }
        }
    };

    const ChangeStatus = async (statusID, newStatus, template_type) => {
        await axios({
          method: 'POST',
          url: `${process.env.REACT_APP_BACKEND_URL}/api/v1/email/template/status`,
          data: {
            biz_id: biz_id,
            template_id: statusID,
            template_status: newStatus,
            template_type: template_type
          }
        }).then(({ data, status }) => {
            getTemplate()
        }, ({ response }) => {

        })
    };


    const testTemplate = async () => {
        try {
            setLoading(true);
            await axios({
                method: 'POST',
                url: `${process.env.REACT_APP_BACKEND_URL}/api/v1/email/mail-send/test`,
                data: {
                    biz_id: biz_id ,
                    template_id : templateID
                }
            })
            let timerInterval;
            Swal.fire({
                title: "กำลังดำเนินการส่งอีเมล...",
                timer: 3000,
                timerProgressBar: true,
                didOpen: () => {
                    Swal.showLoading();
                },
                willClose: () => {
                    clearInterval(timerInterval);
                }
            }).then((result) => {

                if (result.dismiss === Swal.DismissReason.timer) {
                    Swal.close();
                    Swal.fire({
                        icon: 'success',
                        title: 'ดำเนินการส่งอีเมลสำเร็จ',
                    });
                }
            });
    
        } catch (error) {
            // const { response } = error;
            // const { status } = response || {}; // Safeguard if response is undefined
            Swal.close();
            Swal.fire({
                icon: 'error',
                title: 'ดำเนินการส่งอีเมลไม่สำเร็จ',
            });
        } finally {
            setLoading(false);
        }
    };

    const columns = [
        {
            title: 'ลำดับ',
            width: 20,
            dataIndex: 'index',
            key: 'index',
            fixed: 'center',
            align: 'center',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            sorter: (a, b) => a.index - b.index,
              render: (_, __, index) => {
                  return (
                  <>{((page * pageSize) - pageSize) + index + 1}</>
                  )
              }
        },
        {
            title: 'ชื่อ Template',
            width: 150,
            dataIndex: 'template_name',
            key: 'template_name',
            fixed: 'center',
            align: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"]
        },
        {
            title: 'ประเภท',
            width: 50,
            dataIndex: 'template_type',
            key: 'template_type',
            fixed: 'center',
            align: 'center',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"]
        },
        {
            title: 'ดำเนินการโดย',
            width: 50,
            dataIndex: 'operated',
            key: 'operated',
            fixed: 'center',
            align: 'center',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"]
        },
        {
            title: 'วันที่ (เพิ่ม/แก้ไข)',
            width: 50,
            dataIndex: 'date',
            key: 'date',
            fixed: 'center',
            align: 'center',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"]
        },
        {
            title: 'เปิดใช้งาน',
            width: 40,
            dataIndex: 'enabled',
            key: 'enabled',
            fixed: 'center',
            align: 'center',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            render: (_, record) => {
                return (
                    <EnabledSwitch
                        sx={{ m: 1 }}
                        checked={record.enabled}
                        onChange={(event) => handleSwitchChange(event, record)}
                    />
                );
            }
        },
        {
            title: 'ตัวเลือก',
            width: 40,
            dataIndex: 'operation',
            key: 'operation',
            fixed: 'center',
            align: 'center',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            render: (_, record) => (
                <Dropdown
                    overlay={
                        <Menu>
                            <Menu.Item key="info">
                                <Button startIcon={<FileSearchOutlined />} variant="text" onClick={() => handleInfo(record)}>ดูรายละเอียด</Button>
                            </Menu.Item>
                            <Menu.Item key="edit">
                                <Button startIcon={<CreateIcon />} variant="text" onClick={() => handleEdit(record)}>แก้ไขข้อมูล</Button>
                            </Menu.Item>
                            <Menu.Item key="delete">
                                <Button startIcon={<DeleteForeverOutlinedIcon />} variant="text" onClick={() => handleDelete(record)}>ลบข้อมูล</Button>
                            </Menu.Item>
                        </Menu>
                    }
                    trigger={['click']}
                >
                    <Button
                        variant="outlined"
                        startIcon={<UnorderedListOutlined />}
                        style={{
                            width: 40,
                            height: 40,
                            borderRadius: '50%',
                            minWidth: 0,
                            padding: 0,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'right',
                            border: 'none',
                            marginLeft: '15px'
                        }}
                        sx={!!style.primary_color && {
                            backgroundColor: `${style.secondary_color} !important`,
                            color: fontColor(style.secondary_color)
                        }}
                    />
                </Dropdown>
            )
        },
    ];

    const titleTemplate = {
       fontSize: '16px', 
       fontWeight: 'bold'
    };

    const inputTemplate = { 
        height: '40px', 
        borderColor: '#ccc', 
        borderRadius: '4px'
    };

    
    return (<FadeIn>
        {
            {
                "home": (
                    <>
                        <div>
                            <h3 style={{ color: 'black', fontWeight: 'bold', margin: 10, marginBottom: 30 }}>ตั้งค่า TEMPLATE อีเมล</h3>
                        </div>
                        <Card style={{ borderRadius: '16px' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Button
                                    variant="contained"
                                    style={{
                                        width: 200,
                                        height: 40,
                                        marginLeft: 0,
                                        marginRight: 'auto',
                                        marginTop: 12,
                                    }}
                                    sx={!!style.primary_color && {
                                        backgroundColor: `${style.secondary_color} !important`,
                                        color: fontColor(style.secondary_color)
                                    }}
                                    startIcon={<AddIcon />}
                                    onClick={() => {
                                        setStep('setting')
                                    }}
                                >
                                    เพิ่ม TEMPLATE อีเมล
                                </Button>

                                <div
                                    style={{
                                        position: 'relative',
                                        display: 'inline-block',
                                        margin: 20,
                                        marginTop: 5,
                                    }}
                                >
                                    <input
                                        placeholder="ค้นหา"
                                        value={searchText}
                                        style={{
                                            position: 'relative',
                                            width: '380px',
                                            height: '36px',
                                            border: '1px solid #EEEEEE',
                                            backgroundColor: '#FFFFFF',
                                            borderRadius: '6px',
                                            marginTop: '40px',
                                            marginRight: '15px',
                                            marginBottom: '10px',
                                            padding: '10px',
                                            paddingRight: '2.5rem',
                                        }}
                                        onChange={(e) => {
                                            setSearchText(e.target.value);
                                        }}
                                    />
                                    <SearchIcon
                                        style={{
                                            position: 'absolute',
                                            top: '54%',
                                            left: '21.5rem',
                                            color: '#DADADA',
                                        }}
                                    />
                                </div>
                            </div>
                            <Table
                                locale={customLocale}
                                columns={columns}
                                dataSource={listData}
                                scroll={{
                                    x: 1400,
                                    y: 400,
                                }}
                                pagination={{
                                    page: page,
                                    current: page,
                                    defaultCurrent: page,
                                    pageSize: pageSize,
                                    onChange: (page, pageSize) => {
                                        setPage(page)
                                        setPageSize(pageSize)
                                    },
                                    // total: resulttotal,
                                    showSizeChanger: true,
                                    style: paginationStyle
                                }}
                            />
                        </Card>
                    </>
                ),
                "setting": (
                    <>
                        <div>
                            <h3 style={{ color: 'black', display: 'flex', alignItems: 'center', fontWeight: 'bold', margin: 10, marginBottom: 30 }}>
                                <span
                                    onClick={() => {
                                        setStep('home');
                                        setTemplateName('');
                                        setTemplateSubject('');
                                        setTemplateDetail('');
                                        setSelectValue('');
                                        setErrors({});
                                    }}
                                    style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                                >
                                    <ArrowBackIosIcon style={{ fontSize: '35px', marginBottom: '10px' }} />
                                    เพิ่ม TEMPLATE อีเมล
                                </span>
                            </h3>
                        </div>
                        <Row>
                            <Col xs={9}>
                                <Card style={{ borderRadius: '16px' }}>
                                    <div style={{ padding: '30px' }}>
                                        <Row>
                                            <Col xs={2}>
                                                <span style={titleTemplate}>ชื่อ Template :</span>
                                            </Col>
                                            <Col xs={9}>
                                                <Input
                                                    placeholder="ชื่อ Template"
                                                    style={inputTemplate}
                                                    value={templateName}
                                                    onChange={(e) => setTemplateName(e.target.value)}
                                                />
                                                {errors.templateName && <span style={{ color: 'red', fontWeight: 'bold' }}>{errors.templateName}</span>}
                                            </Col>
                                            <Col xs={2} style={{ marginTop: '30px' }}>
                                                <span style={titleTemplate}>หัวข้อ อีเมล :</span>
                                            </Col>
                                            <Col xs={9} style={{ marginTop: '30px' }}>
                                                <Input
                                                    value={templateSubject}
                                                    placeholder="หัวข้อ อีเมล"
                                                    style={inputTemplate}
                                                    onChange={(e) => setTemplateSubject(e.target.value)}
                                                />
                                                {errors.templateSubject && <span style={{ color: 'red', fontWeight: 'bold' }}>{errors.templateSubject}</span>}
                                            </Col>
                                            <Col xs={12} style={{ marginTop: '30px' }}>
                                                <div>
                                                    <Typography.Title level={5}>รายละเอียด</Typography.Title>
                                                    <Box sx={{ width: '100%', typography: 'body1' }}>
                                                        <TabContext value={valueTab}>
                                                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                                                <TabList onChange={(e, newValue) => setValueTab(newValue)} aria-label="lab API tabs example" textColor="secondary" indicatorColor="secondary"
                                                                    TabIndicatorProps={{
                                                                        sx: !!style.secondary_color && {
                                                                            backgroundColor: `${style.secondary_color} !important`,
                                                                            color: fontColor(style.primary_color)
                                                                        }
                                                                    }}>
                                                                    <Tab label="EDITOR" value="1" />
                                                                </TabList>
                                                            </Box>
                                                            <TabPanel value="1">
                                                                <ReactQuill
                                                                    ref={quillRef}
                                                                    style={{
                                                                        height: '250px',
                                                                        color: '#000',
                                                                        background: '#fff',
                                                                        width: '100%',
                                                                    }}
                                                                    value={templateDetail}
                                                                    theme="snow"
                                                                    onChange={(value) => setTemplateDetail(value)}
                                                                    placeholder="กรอกรายละเอียด"
                                                                    onQuillReady={(quill) => {
                                                                        quillRef.current = quill;
                                                                    }}
                                                                />

                                                            </TabPanel>
                                                        </TabContext>

                                                    </Box>

                                                </div>

                                            </Col>
                                            {errors.templateDetail && <span style={{ color: 'red', fontWeight: 'bold', paddingTop: '20px', paddingLeft: '32px' }}>{errors.templateDetail}</span>}
                                            <Col style={{ marginTop: '85px', marginRight: '30px' }} className="d-flex justify-content-end">
                                                <Button
                                                    style={{ width: '200px', fontSize: '16px', marginRight: '10px' }}
                                                    sx={!!style.primary_color && {
                                                        backgroundColor: `${style.secondary_color} !important`,
                                                        color: fontColor(style.secondary_color)
                                                    }}
                                                    onClick={() => {
                                                        createTemplate()
                                                    }}
                                                >
                                                    เพิ่ม TEMPLATE
                                                </Button>
                                                <Button
                                                    startIcon={<CloseCircleOutlined />}
                                                    variant="outlined" color="error"
                                                    style={{ width: '200px', fontSize: '16px' }}
                                                    onClick={() => {
                                                        setStep('home')
                                                        setTemplateName('')
                                                        setTemplateSubject('')
                                                        setTemplateDetail('')
                                                        setSelectValue('')
                                                        setErrors({})
                                                    }}
                                                >
                                                    ยกเลิก
                                                </Button>
                                            </Col>
                                        </Row>
                                    </div>
                                </Card>
                            </Col>

                            <Col xs={3}>
                                <Card >
                                    
                                    {/* <Col xs={12}>
                                        <span style={{ fontSize: '16px', display: 'block', marginTop: '25px' }}>
                                            เลือกส่วนที่ต้องการแสดงข้อมูล
                                        </span>
                                    </Col> */}
                                    <Col xs={12}>
                                        <span style={{ fontSize: '20px', fontWeight: 'bold' }}>ตัวเลือก</span>
                                    </Col>
                                    <Col xs={12} >
                                        <InputLabel style={{ fontSize: '16px', display: 'block', marginTop: '25px' }} id="type-mail-form"><span style={{ color: 'red' }}>*</span> ประเภทอีเมล</InputLabel>
                                        <Select displayEmpty  labelId="type-mail-form" id="type-mail-form" value={selectType}  onChange={handleSelectTypeChange} style={{ width: '100%', height: '35px', marginTop: '15px' }} >
                                            {templateAvailable.map(({ key, label }) => (
                                                <MenuItem key={key} value={key}>
                                                    {label}
                                                </MenuItem>
                                            ))}
                                        </Select> 
                                    </Col>
                                   
                                    <Col xs={12}>
                                    <label style={{ fontSize: '16px', display: 'block', marginTop: '25px' }} htmlFor="type-mail-form"> เลือกส่วนที่ต้องการแสดงข้อมูล</label>
                                        <Radio.Group onChange={handleRadioChange} style={{ display: 'block', marginTop: '15px' }}>
                                            <Radio value={"หัวข้อ"} style={{ fontSize: '16px' }}>หัวข้อ</Radio>
                                            <Radio value={"เนื้อหา"} style={{ fontSize: '16px' }}>เนื้อหา</Radio>
                                        </Radio.Group>
                                    </Col> 
                                    <Col xs={12}>
                                        <InputLabel style={{ fontSize: '16px', display: 'block', marginTop: '25px' }} id="select-data-key"> ข้อมูลเบื่องต้น</InputLabel>
                                        <Select labelId='select-data-key' id="select-data-key" placeholder='​เลือกข้อมูลที่ต้องการ'  displayEmpty value={selectValue} onChange={handleSelectChange} style={{ width: '100%', height: '35px', marginTop: '15px' }} >
                                            <MenuItem value={'ชื่อผู้ใช้'}>ชื่อผู้ใช้</MenuItem>
                                            <MenuItem value={'รหัสผ่าน'}>รหัสผ่าน</MenuItem>
                                            <MenuItem value={'ชื่อองค์กร'}>ชื่อองค์กร</MenuItem>
                                            <MenuItem value={'อีเมลผู้รับ'}>อีเมลผู้รับ</MenuItem>
                                            <MenuItem value={'ชื่อผู้รับ(TH)'}>ชื่อผู้รับ(ภาษาไทย)</MenuItem>
                                            <MenuItem value={'ชื่อผู้รับ(EN)'}>ชื่อผู้รับ(ภาษาอังกฤษ)</MenuItem>
                                            <MenuItem value={'อีเมลสำหรับแจ้งปัญหา'}>อีเมลสำหรับแจ้งปัญหา</MenuItem>
                                            <MenuItem value={'ลิ้งเว็บไซต์'}>ลิ้งเว็บไซต์</MenuItem>
                                            {
                                                isRenewCa && [
                                                    <MenuItem key="expiry_ca" value={'วันหมดอายุ(ca)'}>วันหมดอายุ CA</MenuItem>,
                                                    <MenuItem key="certname_ca" value={'ชื่อใบรับรอง'}>ชื่อใบรับรอง CA</MenuItem>
                                                ]
                                            }
                                        </Select>
                                    </Col> 
                                </Card>
                            </Col>
                        </Row>
                    </>
                ),
                "info": (
                    <>
                        <div>
                            <h3 style={{ color: 'black', fontWeight: 'bold', margin: 10, marginBottom: 30 }}>
                                <span
                                    onClick={() => setStep('home')}
                                    style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                                >
                                    <ArrowBackIosIcon style={{ fontSize: '35px', marginBottom: '10px' }} />
                                    รายละเอียด TEMPLATE อีเมล
                                </span>
                            </h3>
                        </div>
                        <Card
                            title={
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <span style={{ fontSize: '24px', fontWeight: '100' }}>{templateNameDetail}</span>
                                    <Button
                                        style={{ marginLeft: 'auto' }}
                                        sx={!!style.primary_color && {
                                            backgroundColor: `${style.secondary_color} !important`,
                                            color: fontColor(style.secondary_color)
                                        }}
                                        onClick={() => {
                                            testTemplate()
                                        }}
                                    >
                                        ทดสอบส่ง อีเมล
                                    </Button>
                                </div>
                            }
                            style={{ borderRadius: '16px', minHeight: '440px' }}
                        >
                            <Row>
                                <Col xs={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative' }}>
                                    <div
                                        ref={setCardRef}
                                        style={{
                                            width: '90%',
                                            height: 'auto',
                                            marginTop: '20px'
                                        }}
                                    >
                                        <div>
                                            <Row>
                                                <Col xs={12} style={{ marginTop: '15px' }}>
                                                    <span style={{ fontSize: '16px', fontWeight: 'bold' }}>เรื่อง</span> <span style={{ fontSize: '16px' }}>{templateSubjectDetail}</span>
                                                </Col>
                                                <Col xs={12} style={{ marginTop: '15px' }}>
                                                    <span
                                                        style={{ fontSize: '16px' }}
                                                        dangerouslySetInnerHTML={{ __html: templateDetailInfo }}
                                                    />
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Card>
                    </>
                ),
                "edit": (
                    <>
                        <div>
                            <h3 style={{ color: 'black', fontWeight: 'bold', margin: 10, marginBottom: 30 }}>
                                <span
                                    onClick={() => setStep('home')}
                                    style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                                >
                                    <ArrowBackIosIcon style={{ fontSize: '35px', marginBottom: '10px' }} />
                                    แก้ไข TEMPLATE อีเมล
                                </span>
                            </h3>
                        </div>
                        <Row>
                            <Col xs={9}>
                                <Card style={{ borderRadius: '16px' }}>
                                    <div style={{ padding: '30px' }}>
                                        <Row>
                                            <Col xs={2}>
                                                <span style={titleTemplate}>ชื่อ Template :</span>
                                            </Col>
                                            <Col xs={9}>
                                                <Input
                                                    name="template_name"
                                                    placeholder="ชื่อ Template"
                                                    style={inputTemplate}
                                                    value={templateEditObj.template_name}
                                                    onChange={handleEditChange}
                                                />
                                                {errors.templateNameEdit && <span style={{ color: 'red', fontWeight: 'bold' }}>{errors.templateNameEdit}</span>}
                                            </Col>

                                            <Col xs={2} style={{ marginTop: '30px' }}>
                                                <span style={titleTemplate}>หัวข้อ อีเมล :</span>
                                            </Col>
                                            <Col xs={9} style={{ marginTop: '30px' }}>
                                                <Input
                                                    name="template_subject"
                                                    value={templateEditObj.template_subject}
                                                    placeholder="หัวข้อ อีเมล"
                                                    style={inputTemplate}
                                                    onChange={handleEditChange}
                                                />
                                                {errors.templateSubjectEdit && <span style={{ color: 'red', fontWeight: 'bold' }}>{errors.templateSubjectEdit}</span>}
                                            </Col>

                                            <Col xs={12} style={{ marginTop: '30px' }}>
                                                <Typography.Title level={5}>รายละเอียด</Typography.Title>
                                                <Box sx={{ width: '100%', typography: 'body1' }}>
                                                    <TabContext value={valueTab}>
                                                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                                            <TabList onChange={(e, newValue) => setValueTab(newValue)} aria-label="Edit Email Template Tabs" textColor="secondary" indicatorColor="secondary"
                                                                TabIndicatorProps={{
                                                                    sx: !!style.secondary_color && {
                                                                        backgroundColor: `${style.secondary_color} !important`,
                                                                        color: fontColor(style.primary_color)
                                                                    }
                                                                }}
                                                            >
                                                                <Tab label="EDITOR" value="1" />
                                                            </TabList>
                                                        </Box>
                                                        <TabPanel value="1">
                                                            <ReactQuill
                                                                ref={quillRef}
                                                                style={{
                                                                    height: '250px',
                                                                    color: '#000',
                                                                    background: '#fff',
                                                                    width: '100%',
                                                                }}
                                                                value={templateEditObj.template_detail}
                                                                theme="snow"
                                                                onChange={(value) => handleEditChange({ target: { name: "template_detail", value } })}
                                                                placeholder="กรอกรายละเอียด"
                                                            />
                                                        </TabPanel>
                                                    </TabContext>
                                                </Box>
                                                {errors.templateDetailEdit && <span style={{ color: 'red', fontWeight: 'bold', paddingTop: '20px', paddingLeft: '32px' }}>{errors.templateDetailEdit}</span>}
                                            </Col>

                                            <Col style={{ marginTop: '85px', marginRight: '30px' }} className="d-flex justify-content-end">
                                                <Button
                                                    style={{ width: '200px', fontSize: '16px', marginRight: '10px' }}
                                                    sx={!!style.primary_color && {
                                                        backgroundColor: `${style.secondary_color} !important`,
                                                        color: fontColor(style.secondary_color)
                                                    }}
                                                    onClick={saveEditTemplate}
                                                >
                                                    บันทึกการแก้ไข
                                                </Button>
                                                <Button
                                                    startIcon={<CloseCircleOutlined />}
                                                    variant="outlined" color="error"
                                                    style={{ width: '200px', fontSize: '16px' }}
                                                    onClick={() => {
                                                        setStep('home')
                                                        setTemplateEditObj({})
                                                        setErrors({})
                                                    }}
                                                >
                                                    ยกเลิก
                                                </Button>
                                            </Col>
                                        </Row>
                                    </div>
                                </Card>
                            </Col>
                            <Col xs={3}>
                                <Card>
                                    <Col xs={12}>
                                        <span style={{ fontSize: '16px', fontWeight: 'bold' }}>ตัวเลือก</span>
                                    </Col>
                                    <Col xs={12}>
                                        <span style={{ fontSize: '16px', display: 'block', marginTop: '25px' }}>
                                            เลือกส่วนที่ต้องการแสดงข้อมูล
                                        </span>
                                    </Col>
                                    <Col xs={12}>
                                        <Radio.Group onChange={handleRadioChange} style={{ display: 'block', marginTop: '15px' }}>
                                            <Radio value={"หัวข้อ"} style={{ fontSize: '16px' }}>หัวข้อ</Radio>
                                            <Radio value={"เนื้อหา"} style={{ fontSize: '16px' }}>เนื้อหา</Radio>
                                        </Radio.Group>
                                    </Col>
                                    <Col xs={12}>
                                        <span style={{ fontSize: '16px', display: 'block', marginTop: '25px' }}>
                                            ข้อมูล
                                        </span>
                                    </Col>
                                    <Col xs={12}>
                                        <Select
                                            displayEmpty
                                            value={selectValue}
                                            onChange={handleSelectEditChange}
                                            style={{ width: '100%', height: '35px', marginTop: '15px' }}
                                        >
                                            <MenuItem value="" disabled>
                                                เลือกข้อมูลที่ต้องการ
                                            </MenuItem>
                                            <MenuItem value={'ชื่อผู้ใช้'}>ชื่อผู้ใช้</MenuItem>
                                            <MenuItem value={'รหัสผ่าน'}>รหัสผ่าน</MenuItem>
                                            <MenuItem value={'ชื่อองค์กร'}>ชื่อองค์กร</MenuItem>
                                            <MenuItem value={'อีเมลผู้รับ'}>อีเมลผู้รับ</MenuItem>
                                            <MenuItem value={'ชื่อผู้รับ(TH)'}>ชื่อผู้รับ(ภาษาไทย)</MenuItem>
                                            <MenuItem value={'ชื่อผู้รับ(EN)'}>ชื่อผู้รับ(ภาษาอังกฤษ)</MenuItem>
                                            <MenuItem value={'อีเมลสำหรับแจ้งปัญหา'}>อีเมลสำหรับแจ้งปัญหา</MenuItem>
                                            <MenuItem value={'ลิ้งเว็บไซต์'}>ลิ้งเว็บไซต์</MenuItem>
                                            {
                                                isRenewCaUpdate && [
                                                    <MenuItem key="expiry_ca" value={'วันหมดอายุ(ca)'}>วันหมดอายุ CA</MenuItem>,
                                                    <MenuItem key="certname_ca" value={'ชื่อใบรับรอง'}>ชื่อใบรับรอง CA</MenuItem>
                                                ]
                                            }
                                        </Select>
                                    </Col>

                                    <Col xs={12}>
                                        <span style={{ fontSize: '16px', display: 'block', marginTop: '25px' }}>
                                            ประเภทอีเมล
                                        </span>
                                    </Col>
                                    <Col xs={12}>
                                        <div style={{ width: '100%', height: '35px', marginTop: '15px' }}>
                                            {templateDisplay[templateEditObj.template_type] || 'one-id'}
                                        </div>
                                    </Col>
                                </Card>
                            </Col>
                        </Row>
                    </>
                )
            }[step]
        }
    </FadeIn>
  )
}

export default EmailTemplate